module.exports = __webpack_public_path__ + "img/zipper.a20eea39.svg";